import { 
	ChangePasswordData, ChangePasswordResponse, IChangePassword,
} from "@/types/models/services/user/changePassword";


import API from "./api";

export enum Endpoints {
	ChangePassword = "/user/password",
}

const changePassword = ({
	currentPassword,
	newPassword
}: IChangePassword) => {
	return new Promise<ChangePasswordResponse>(async (resolve, reject) => {
		API.put<ChangePasswordResponse, ChangePasswordData>({
			endpoint: Endpoints.ChangePassword,
			data: {
				current: currentPassword, 
				password: newPassword
			}
		})
		.then(res => {
			if(res.promise.data.status === "ERROR") {
				reject(res.promise.data);
			} else {
				resolve(res.promise.data);
			}
		})
		.catch(err => {
			reject(err);
		})
	})
}


export default {
	changePassword
};
